module.exports = __webpack_public_path__ + "static/media/s.5.d7261052.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/HaritonovaPrepravka1/assets/s.5.jpg
// module id = 221
// module chunks = 0